import Vue from 'vue';
import { AccessibleRadioMixin } from '../mixins/accessibleRadioMixin';

Vue.component('radio-input', {
    mixins: [AccessibleRadioMixin],

    props: {
        checked: {
            type: String,
        },
        groupName: {
            type: String,
        },
        customChangeHandler: {
            type: String,
        },
    },

    data() {
        return {
            checkedId: '',
            idToValueMap: {}, // Map IDs to values for proper event handling
        };
    },

    mounted() {
        if (this.checked) {
            this.checkedId = this.checked;
        }

        // Build ID to value mapping from radio inputs in the DOM
        this.buildIdValueMap();

        // Call the mixin's mounted logic
        if (this.$options.mixins) {
            this.$options.mixins.forEach((mixin) => {
                if (mixin.mounted) {
                    mixin.mounted.call(this);
                }
            });
        }
    },

    destroyed() {},

    watch: {},

    methods: {
        /**
         * Build mapping between radio input IDs and their values
         */
        buildIdValueMap() {
            const radioInputs = this.$el.querySelectorAll(
                'input[type="radio"]',
            );
            this.idToValueMap = {};

            radioInputs.forEach((input) => {
                this.idToValueMap[input.id] = input.value;
            });
        },

        checkIsSelected(value) {
            if (this.checkedId == value) return true;
            return false;
        },

        // Method for the mixin to check selection by ID
        checkIsSelectedById(id) {
            const value = this.idToValueMap[id];
            return this.checkIsSelected(value);
        },

        getGender() {
            return this.checkedId;
        },

        // Override the mixin's changeSelected to handle both ID and value scenarios
        changeSelected(idOrValue) {
            let value = idOrValue;
            let id = idOrValue;

            // If this is an ID (from keyboard navigation), get the corresponding value
            if (this.idToValueMap[idOrValue]) {
                value = this.idToValueMap[idOrValue];
                id = idOrValue;
            } else {
                // If this is a value (from click), find the corresponding ID
                for (const [mappedId, mappedValue] of Object.entries(
                    this.idToValueMap,
                )) {
                    if (mappedValue === idOrValue) {
                        id = mappedId;
                        break;
                    }
                }
            }

            this.checkedId = value;

            // Call the mixin's method manually with the ID for focus management
            this.focusedItem = id;
            this.updateTabIndexes(id);
            this.announceSelection(id);

            // Emit event to parent component with the value
            if (this.groupName) {
                const syntheticEvent = {
                    target: { value: value },
                };

                // Use custom change handler if provided
                if (
                    this.customChangeHandler &&
                    this.$parent[this.customChangeHandler]
                ) {
                    this.$parent[this.customChangeHandler](syntheticEvent);
                }
                // Otherwise use default handlers based on group name
                else if (
                    this.groupName === 'downPaymentEntry' &&
                    this.$parent.handleDownPaymentEntrySelect
                ) {
                    this.$parent.handleDownPaymentEntrySelect(syntheticEvent);
                } else if (
                    this.groupName === 'months' &&
                    this.$parent.handleMonthsSelect
                ) {
                    this.$parent.handleMonthsSelect(syntheticEvent);
                } else if (
                    this.groupName === 'kilometers' &&
                    this.$parent.handleMileageSelect
                ) {
                    this.$parent.handleMileageSelect(syntheticEvent);
                }
                // For v-model compatibility (like promoType in SCF modal)
                else if (
                    this.groupName &&
                    this.$parent[this.groupName] !== undefined
                ) {
                    this.$parent[this.groupName] = value;
                }
            }
        },
    },
});
